import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {

  constructor(private http: HttpClient) { }
  private token = '';

  postlogin(payload: any) {
    const headers = new HttpHeaders({
      // 'Authorization': 'Basic c2NlbXBsb3llZTpzZWNyZXQ=',
      // "Content-Type": 'application/x-www-form-urlencoded'
    });
    return this.http.post(environment.employeeURL + '/jwtV2/employee/token', payload, { headers })
  }

  accountDelete(deleted: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.post(environment.employeeURL + '/jwtV2/api/common/inactiveEmpAppAccountStatus', deleted, { headers })
  }
}
